import * as React from 'react';
import Urls from '@/config/url';
import https from '@/utils/ajaxUtils';
import { message, } from 'antd';
import moment from 'moment';

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      type: null,
      selected: null,
      detail: null,
      detailContent: null,
      selectedClass: null,
      tcIndex: -1
    };
  }
  UNSAFE_componentWillMount() {
    console.log('this.props.location.state: ', this.props.location.state);
    // console.log('this.props.location.state.selectedClass: ', this.props.location.state);
    if (this.props.location.state) {
      if (this.props.location.state.id && this.props.location.state.type) {
        this.setState({
          id: this.props.location.state.id,
          type: this.props.location.state.type,
          tcIndex: this.props.location.state.tcIndex,
          selected: this.props.location.state.selected,
          selectedClass: this.props.location.state.selectedClass,
        }, () => {
          this.getDetail();
        });
      } else {
        message.error('参数错误!');
        return;
      }
    }
  }
  // 获取详情 有2个类型 (case 从简单案例过来的,report 从报告过来的)
  getDetail = async () => {
    const { id, type } = this.state;
    let res1 = null;
    let res2 = null;
    if (type === 'case') {
      res1 = await https.get(Urls.getSimpleCaseDetail.replace('{id}', id), {});
      res2 = await https.get(Urls.getSimpleClassList, { id });
    }
    if (type === 'report') {
      res1 = await https.get(Urls.getReportDetail.replace('{id}', id), {});
      res2 = await https.get(Urls.getReportClassList, { id });
    }
    // console.log('detail详情: ', res);
    // if (!res.success) {
    //   message.error(' 获取数据失败');
    //   return;
    // }
    // if (res.data) {
    //   this.setState({
    //     detail: res.data,
    //     detailContent: res.data.content ? JSON.parse(res.data.content) : null
    //   }, () => {
    //     console.log('详情:', this.state.detail);
    //     console.log('大JSON:', this.state.detailContent);
    //   });
    // }
    if (res1.success && res1.data && res2.success && res2.data) {
      this.setState({
        detail: res1.data,
        detailContent: res2.data,
      }, () => {
        console.log('this.detail', this.state.detail)
      })
    } else {
      message.error('获取数据失败')
    }
  }
  onSelected = (v, index) => {
    this.setState({
      tcIndex: index,
      selected: v.label
    });
    this.getKpList(index);
  }

  // 通过index获取kp列表信息
  getKpList = async (index) => {
    const { type } = this.state
    let res = null
    let param = {
      id: this.state.id,
      tcIndex: index
    }
    if (type === 'case') {
      res = await https.get(Urls.getSimpleCaseKpList, param)
    }
    if (type === 'report') {
      res = await https.get(Urls.getReportKpList, param)
    }

    if (res.success) {
      this.setState({
        selectedClass: res.data
      })
      console.log('reslist', this.state.selectedClass)
    } else {
      message.error('获取数据失败')
    }
  }
  catergorySelected = (index) => {
    console.log('tcIndex', this.state.tcIndex);
    let param = {
      id: this.state.id,
      type: this.state.type,
      tcIndex: this.state.tcIndex,
      kpIndex: index,
      catergorylabel: this.state.selectedClass[index].label,
      classSlected: this.state.selectedClass[index].label_disp,
      selected: this.state.selected,
      selectedClass: this.state.selectedClass,
    }
    this.props.history.push({ pathname: "/service/result/detail", state: param });
    // const param = {
    //   id: this.state.id,
    //   tcIndex: this.state.tcIndex,
    //   kpIndex: index
    // }
    // // const res = await https.get(Urls.getSimpleCaseKpDetail, param)
    // if (res.success) {
    //   console.log('resDetail', res.data)
    // } else {
    //   message.error('获取数据失败')
    // }

    // return

    // 跳转到搜索结果详情 待参数 id,type, catergorylabel
    // let param = {
    //   id: this.state.id,
    //   type: this.state.type,
    //   catergorylabel: data.label,
    //   classSlected: this.state.selectedClass.label,
    //   selected: this.state.selected,
    //   selectedClass: this.state.selectedClass
    // }
    // this.props.history.push({ pathname: "/service/result/detail", state: param });

    // window.location.href = ;
    // window.open('/service/result/detail?param=' + JSON.stringify(param), '_blank');
  }
  render() {
    console.log('detailContent', this.state.detailContent)
    console.log('this.state.selected', this.state.selected)
    const { detailContent, selectedClass, detail } = this.state;
    return (
      <React.Fragment>
        {
          this.state.detail &&
          <React.Fragment>
            <div className="search-result-top">
              <div className="txt">关于<span className="big">{this.state.detail.keyword || this.state.detail.name}</span>的一切</div>
              <div className="date">——
                {(detail && detail.beginTime) ? moment(detail.beginTime).format('YYYY年MM月DD日') : ''}-
                {(detail && detail.endTime) ? moment(detail.endTime).format('YYYY年MM月DD日') : ''}
              </div>
            </div>
            <div className="index-content">
              <div className="search-result">该报告可以细分为以下研究趋势类别</div>
              <div className="main">
                <div className="left" style={{ height: '7.5rem' }}>
                  {
                    detailContent && detailContent.length > 0 &&
                    detailContent.map((v, index) => {
                      return (
                        <div key={v.label} className={"class-item" + (this.state.selected === v.label ? ' selected' : '')} onClick={() => { this.onSelected(v, index); }}>
                          <div className="name">{v.label_disp}</div>
                          <img src={v.label_pic} alt="" />
                        </div>
                      );
                    })
                  }
                </div>
                <div className="right" style={{ height: '7.5rem' }}>
                  {
                    !selectedClass &&
                    <div className="result-no-selected">
                      <div className="item">
                        <div className="title">什么是研究趋势？<span className="orange">点击趋势图可查看详情</span></div>
                        <div className="intro">某个主题相关的所有文献可以被分为多个研究方向，棍棍会将每个研究方向的内容打包成知识颗粒。研究者关心的问题是如何选择和评价某个特定研究方向的价值，因此棍棍将每个研究方向打包成知识颗粒后，就可以用这个知识颗粒来计算一段时间内发表的主题相关的所有文献中包含当前研究方向内容的信息量。从第一篇文献发表到现在，棍棍会按月计算信息量的变化并绘制成趋势曲线图，这条曲线客观地反映出特定研究方向随时间变化的“热度”，因此是一种研究者判断该领域研究价值的友好工具。</div>
                      </div>
                      <div className="item">
                        <div className="title">为什么某些知识颗粒会聚成一类？</div>
                        <div className="intro">研究趋势是棍棍根据特定知识颗粒携带的特定信息在时间上的特定分布，因此，不同知识颗粒的研究趋势可能相近也可能有较大差异。因此，根据研究趋势中信息在时间上的分布的相似性，棍棍自动将研究趋势相近的知识颗粒聚类在一起。这种聚类结果可能会帮助研究者直观的了解哪些知识颗粒中研究内容处于“热点”，研究趋势变化的共性也可以提供部分信息帮助研究者了解不同知识颗粒之间可能具有的潜在联系，提供更好的研究线索。</div>
                      </div>
                    </div>
                  }
                  {
                    selectedClass &&
                    <div className="result-selected">
                      {
                        selectedClass.length > 0 &&
                        selectedClass.map((v, index) => {
                          return (
                            <div className="c-item" key={v.label} onClick={() => { this.catergorySelected(index) }}>{v.label + ':\xa0\xa0' + v.label_disp}</div>
                          );
                        })
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default Result;
